import createReReSelector from 're-reselect';

import { ErrorItem } from '../../components/ErrorsPresenter/ErrorsPresenter';
import { chatListInitialData } from '../../service/ChatListEditor/ChatListEditor';
import {
    ChatListEditorData,
    ChatListEditors,
    ChatListItem
} from '../../typings/chatList';
import { ValidationErrorData } from '../../typings/common';
import { State } from '../../typings/state';

export const selectChatListEditorById = createReReSelector(
    (state: State) => state.chatListEditor.editors,
    (state: State, editorId: string) => editorId,
    (editors: ChatListEditors, editorId: string): ChatListEditorData => {
        return editors[editorId] || chatListInitialData;
    }
)((state: State, editorId: string) => editorId);

export const selectChatListEditorChatsData = (
    state: State
): Array<ChatListItem> | undefined => state.chatListEditor.chats;

export const selectChatsWithFilterChatListEditor = createReReSelector(
    selectChatListEditorById,
    selectChatListEditorChatsData,
    (
        editor: ChatListEditorData,
        chats?: Array<ChatListItem>
    ): ChatListItem[] | undefined => {
        if (!chats || !chats.length || !editor.filteredChats) {
            return chats;
        }

        return editor.filteredChats;
    }
)((state: State, editorId: string) => editorId);

const DEFAULT_CHAT_LIST_EDITOR_ERRORS: Array<ErrorItem> = [];

export const selectChatListEditorErrors = (
    errors?: Array<ValidationErrorData>
): Array<ErrorItem> => {
    if (!errors) {
        return DEFAULT_CHAT_LIST_EDITOR_ERRORS;
    }

    return errors.map((elem: ValidationErrorData) => {
        return {
            path: elem.path || '',
            text: elem.text
        };
    });
};
